// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__h4uTp","content":"styles_content__2iAl7"};